import { render, staticRenderFns } from "./NetsuiteOrder.vue?vue&type=template&id=82708c84&scoped=true&"
import script from "./NetsuiteOrder.vue?vue&type=script&lang=js&"
export * from "./NetsuiteOrder.vue?vue&type=script&lang=js&"
import style0 from "./NetsuiteOrder.vue?vue&type=style&index=0&id=82708c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82708c84",
  null
  
)

export default component.exports